export enum GlassClaimConfirmationConstants {
  TITLE = "Redirecting to Safelite",
  DESCRIPTION = "To file your glass claim, we will direct you to our partner Safelite in a new window.",
  PRIMARY_BUTTON_TEXT = "Go to Safelite",
  SECONDARY_BUTTON_TEXT = "Cancel",
}

export const GenericModalTopMargin = "23%";
